import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const TITLES = {
  "/": "Home", "/chi-sono": "Chi sono", "/aree-di-competenza": "Aree di competenza",
  "/consulenze": "Consulenze", "/supervisioni": "Supervisioni", "/webinar": "Webinar",
  "/blog": "Blog", "/libri": "Pubblicazioni", "/pubblicazioni": "Pubblicazioni", "/eventi": "Eventi",
  "/media": "Media", "/rete": "Rete GSRD", "/rete/iscriviti": "Entra nella Rete", "/contatti": "Contatti",
  "/quando-non-sono-la-persona-giusta": "Quando non sono la persona giusta",
  "/privacy-policy": "Privacy policy", "/cookie-policy": "Cookie policy", "/login": "Accesso", "/admin": "Area admin",
};

// Announces page changes to screen readers and moves focus to the main content
export default function RouteAnnouncer() {
  const { pathname } = useLocation();
  const [msg, setMsg] = useState("");
  const first = useRef(true);

  useEffect(() => {
    const title = TITLES[pathname] || (pathname.startsWith("/blog/") ? "Articolo del blog" : pathname.startsWith("/rete/scheda/") ? "Scheda della Rete" : pathname.startsWith("/aree/") ? "Area di competenza" : "Pagina");
    if (!pathname.startsWith("/rete/scheda/")) document.title = `${title} · Dania (Dan) Piras`;
    if (first.current) { first.current = false; return; }
    setMsg(`Pagina: ${title}`);
    document.getElementById("contenuto")?.focus({ preventScroll: true });
  }, [pathname]);

  return <div className="sr-only" aria-live="polite" aria-atomic="true" data-testid="route-announcer">{msg}</div>;
}
